import userAgreement from '../pages/app/UserAgreement';
import privacyPolicy from '../pages/app/PrivacyPolicy';
import download from '../pages/app/download'

const appRouters = [
    {
        path: '/app/userAgreement',
        name: 'userAgreement',
        component: userAgreement,
    }, {
        path: '/app/privacyPolicy',
        name: 'privacyPolicy',
        component: privacyPolicy,
    }
    , {
        path: '/app/download',
        name: 'download',
        component: download,
    }
    // , {
    //     path: '*',
    //     name: 'download',
    //     component: download,
    // }

]


export default appRouters;
